// extracted by mini-css-extract-plugin
export default {"logo":"LoadingSection_logo__1nRZw","rotateY":"LoadingSection_rotateY__7wnH0"};